/**
 * Fetches application data from the CMS.
 */
export default async (context:any, { oneLni }) => {
    const identifier = 'a63955096ede087db5be2bf768c8ca42';
    const endpoint = `${ oneLni.environment.current.apiLocation2 }/app-text?id=${ identifier }`;

    // `fetch` returns an object with properties `error` (error message) and `result` (data from the CMS)
    const text = await fetch(endpoint, { mode: 'cors' })
        .then(async response => {
            // Request to server failed
            if (!response.ok) {
                throw new Error(`Failed to load request (response code status: ${ response.status })`);
            }
            const data:any = await response.json();

            // Content pull failed
            if (data.error?.length) {
                throw new Error(data.error);
            }

            return data;
        })
        .then(json => json.result)
        .catch(error => {
            console.error(error);
            return null;
        });

    return text;
};